export default __webpack_public_path__ + "static/media/card_client_sa_cx.df72b420.webp";